import { CASES } from './constants';

const initialState = {
    linkedProducts: [],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    rangeParam: [0, 19],
    defaultFilterRange: [0, 19],
    sortParam: ['id', 'ASC'],
    itemsPerPage: 20,
    isProductsModalOpen: false,
    productOptions: [],
    dateAddedMap: [],
    unconfirmedProductIdList: [],
};

/**
 * Reducer function to manage the linked products state in the Redux store.
 *
 * @param state
 * @param action
 * @return {Object} The new state of the linked products after applying the action.
 **/
export function linkedProducts(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_LINKED_PRODUCTS: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_LINKED_PRODUCTS_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_LINKED_PRODUCTS: {
            const { exclude } = payload;
            const newState = { ...initialState };
            exclude?.forEach((key) => {
                newState[key] = state[key];
            });
            return newState;
        }
        default:
            return state;
    }
}
